// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__5IqZ2","inner":"Footer_inner__1KfYQ","nextIcon":"Footer_nextIcon__2YzOa","innerLeft":"Footer_innerLeft__VWxnO"};